import { useSelector } from 'react-redux';
import { Link } from "react-router-dom";

export default function ManagePostLink({ children, id }) {

    const postPath = id ? `/post/manage/${id}` : '/post/manage';
    const { token } = useSelector((state) => state.environment);

    return (
        <div className="manage-post-link">
            {token && <Link to={postPath}>{children}</Link>}
        </div>);
}